import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { useRef } from 'react';
import { useState } from 'react';

const TITLE = 'CSS Reference - Grid';

const Cssgrid = ({ input, value, onChange, onPickerChange, onSubmit }) => {


    // 서브 카테고리 연결
    const areaRef = useRef(null);
    const autoColumns = useRef(null);
    const autoFlow = useRef(null);
    const autoRows = useRef(null);
    const columnEnd = useRef(null);
    const columnGap = useRef(null);
    const columnStart = useRef(null);
    const column = useRef(null);
    const gapRef = useRef(null);
    const rowEnd = useRef(null);
    const rowGap = useRef(null);
    const rowStart = useRef(null);
    const rowRef = useRef(null);
    const templateAreas = useRef(null);
    const templateColumns = useRef(null);
    const templateRows = useRef(null);
    const template = useRef(null);
    const grid = useRef(null);

    const scrollToRef = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // 클릭 시 복사
    const clickCopyText = (event) => {
        const textToCopy = event.target.innerText;
        navigator.clipboard.writeText(textToCopy).then(() => {
            event.target.classList.add('copied');
            setTimeout(() => {
                event.target.classList.remove('copied');
            }, 1000);
        }).catch(err => {
            console.error('텍스트 복사 실패', err);
        });
    }

    return (
        <>
            <Helmet>
                <title>{TITLE}</title>
                <meta name="description" content="" />
            </Helmet>

            <div className="top-title css">
                <h2>CSS Reference</h2>
                <p>다양한 CSS 속성 예시를 확인하고, 간단하게 복사해서 활용해보세요.</p>
            </div>

            <div className="menu-wrap">
                <div className="menu-type css">
                    <ul>
                        <Link to="/css-ref"><li>All</li></Link>
                        <Link to="/css-ref/animations"><li>Animations</li></Link>
                        <Link to="/css-ref/backgrounds"><li>Backgrounds</li></Link>
                        <Link to="/css-ref/boxmodel"><li>Box model</li></Link>
                        <Link to="/css-ref/flexbox"><li>Flexbox</li></Link>
                        <Link to="/css-ref/cssgrid"><li className='checked'>CSS Grid</li></Link>
                        <Link to="/css-ref/positioning"><li>Positioning</li></Link>
                        <Link to="/css-ref/transitions"><li>Transitions</li></Link>
                        <Link to="/css-ref/typography"><li>Typography</li></Link>
                    </ul>
                </div>

                <div className="menu-type css category">
                    <ul>
                        <li onClick={() => scrollToRef(areaRef)}>grid-area</li>
                        <li onClick={() => scrollToRef(autoColumns)}>grid-auto-columns</li>
                        <li onClick={() => scrollToRef(autoFlow)}>grid-auto-flow</li>
                        <li onClick={() => scrollToRef(autoRows)}>grid-auto-rows</li>
                        <li onClick={() => scrollToRef(columnEnd)}>grid-column-end</li>
                        <li onClick={() => scrollToRef(columnGap)}>grid-column-gap</li>
                        <li onClick={() => scrollToRef(columnStart)}>grid-column-start</li>
                        <li onClick={() => scrollToRef(column)}>grid-column</li>
                        <li onClick={() => scrollToRef(gapRef)}>grid-gap</li>
                        <li onClick={() => scrollToRef(rowEnd)}>grid-row-end</li>
                        <li onClick={() => scrollToRef(rowGap)}>grid-row-gap</li>
                        <li onClick={() => scrollToRef(rowStart)}>grid-row-start</li>
                        <li onClick={() => scrollToRef(rowRef)}>grid-row</li>
                        <li onClick={() => scrollToRef(templateAreas)}>grid-template-areas</li>
                        <li onClick={() => scrollToRef(templateColumns)}>grid-template-columns</li>
                        <li onClick={() => scrollToRef(templateRows)}>grid-template-rows</li>
                        <li onClick={() => scrollToRef(template)}>grid-template</li>
                        <li onClick={() => scrollToRef(grid)}>grid</li>
                    </ul>
                </div>
            </div>

            <div className="css-reference-content" ref={areaRef}>
                <div className="name">grid-area</div>
                <div className="define">Shorthand property for grid-row-start grid-column-start grid-row-end and grid-column-end.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-area: auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            The grid item's column and row starts and ends are automatically set.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid area type1">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-area: main;</div>
                        </div>
                        <div className="property-define">
                            You can use an area name.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid area type2">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-purple">Footer</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={autoColumns}>
                <div className="name">grid-auto-columns</div>
                <div className="define">Defines the size of grid columns that were created implicitly: it means that grid-auto-columns targets the columns that were not defined with grid-template-columns or grid-template-areas.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-auto-columns: auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            The implicity-created columns have an auto size.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid auto-columns type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-auto-columns: 100px;</div>
                        </div>
                        <div className="property-define">
                            Here we combine grid-template-areas: "header header header" "sidebar main main" with grid-template-columns: 50px 200px.<br />

                            In this situation, the grid-template-areas defines 3 columns, while the grid-template-columns only defines 2 column widths.<br />

                            As a result, the third column width takes its value from the grid-auto-columns property: 100px.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid auto-columns type2">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                    <div className="block block-yellow">50px</div>
                                    <div className="block block-purple">200px</div>
                                    <div className="block block-orange">100px</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={autoFlow}>
                <div className="name">grid-auto-flow</div>
                <div className="define">Defines the position of auto-generated grid items.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-auto-flow: row;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            Here we have grid-template-areas: "header header header" "sidebar main main" "footer footer footer", plus an additional "Other" grid item. The algorithm places it on its own row.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid auto-flow type1">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                    <div className="block block-yellow">Footer</div>
                                    <div className="block block-purple">Other</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-auto-flow: column;</div>
                        </div>
                        <div className="property-define">
                            Here we have grid-template-areas: "header header header" "sidebar main main" "footer footer footer", plus an additional "Other" grid item. The algorithm places it in its own column.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid auto-flow type2">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                    <div className="block block-yellow">Footer</div>
                                    <div className="block block-purple">Other</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={autoRows}>
                <div className="name">grid-auto-rows</div>
                <div className="define">Defines the size of grid rows that were created implicitly: it means that grid-auto-rows targets the rows that were not defined with grid-template-rows or grid-template-areas.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-auto-rows: auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            The implicity-created rows have an auto size.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid auto-rows type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-auto-rows: 100px;</div>
                        </div>
                        <div className="property-define">
                            Here we combine grid-template-areas: "header header header" "sidebar main main" "footer footer footer" with grid-template-rows: 50px 200px.

                            In this situation, the grid-template-areas defines 3 rows, while the grid-template-rows only defines 2 row heights.

                            As a result, the third row height (the footer) takes its value from the grid-auto-rows property: 100px.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid auto-rows type2">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                    <div className="block block-yellow">Footer: 100px high</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={columnEnd}>
                <div className="name">grid-column-end</div>
                <div className="define">Defines the column end position of a grid item.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-end: auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            In this 3-column setup, the grid item is automatically placed.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-end type1">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-end: 2;</div>
                        </div>
                        <div className="property-define">
                            The target grid item ends just before the second column.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-end type2">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-end: 1;</div>
                        </div>
                        <div className="property-define">
                            The target grid item ends just before the first column, which automatically creates a fourth column.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-end type3">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={columnGap}>
                <div className="name">grid-column-gap</div>
                <div className="define">Defines the gutter between the columns of a grid container.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-gap: 0;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            Removes the gap.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-gap type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-gap: 10px;</div>
                        </div>
                        <div className="property-define">
                            You can use pixel values.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-gap type2">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-gap: 3rem;</div>
                        </div>
                        <div className="property-define">
                            You can use (r)em values.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-gap type3">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-gap: 20%</div>
                        </div>
                        <div className="property-define">
                            You can use percentage values.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-gap type4">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={columnStart}>
                <div className="name">grid-column-start</div>
                <div className="define">Defines the column start position of a grid item.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-start: auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            In this 3-column setup, the grid item is automatically placed.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-start type1">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-start: 2;</div>
                        </div>
                        <div className="property-define">
                            The target grid item is placed on the second column.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-start type2">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column-start: 4;</div>
                        </div>
                        <div className="property-define">
                            The target grid item is placed outside the grid, in an auto-generated fourth column.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column-start type3">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={column}>
                <div className="name">grid-column</div>
                <div className="define">Shorthand property for grid-column-start and grid-column-end.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column: auto auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            The grid item's column start and end are automatically set.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column type1">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column: 1 / 3;</div>
                        </div>
                        <div className="property-define">
                            The grid item starts before the first column and ends just before the third one.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column type2">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column: span 3;</div>
                        </div>
                        <div className="property-define">
                            The grid item spans 3 columns.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column type3">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column: 1 / span 4;</div>
                        </div>
                        <div className="property-define">
                            The grid items starts before the first column and spans for 4 columns, creating a new one in the process.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column type4">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-column: main;</div>
                        </div>
                        <div className="property-define">
                            You can use an area name to "copy" its column start and end positions.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid column type5">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Siderbar</div>
                                    <div className="block block-yellow">Main</div>
                                    <div className="block block-purple">Footer</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={gapRef}>
                <div className="name">grid-gap</div>
                <div className="define">Shorthand property for grid-row-gap and grid-column-gap.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-gap: 0 0;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            Removes both rows and columns gaps.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid gap type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-gap: 10px;</div>
                        </div>
                        <div className="property-define">
                            You can set a single value.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid gap type2">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-gap: 3rem 1rem;</div>
                        </div>
                        <div className="property-define">
                            You can set a value for each direction: rows first, columns second.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid gap type3">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={rowEnd}>
                <div className="name">grid-row-end</div>
                <div className="define">Defines the row end position of a grid item.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-end: auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            In this 3-column setup, the grid item is automatically placed.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-end type1">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-end: 3;</div>
                        </div>
                        <div className="property-define">
                            The target grid item ends just before the third row.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-end type2">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-end: 4;</div>
                        </div>
                        <div className="property-define">
                            The target grid item ends just before the fourth row, which automatically creates a third row.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-end type3">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={rowGap}>
                <div className="name">grid-row-gap</div>
                <div className="define">Defines the gutter between the rows of a grid container.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-gap: 0;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            Removes the gap.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-gap type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-gap: 10px;</div>
                        </div>
                        <div className="property-define">
                            You can use pixel values.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-gap type2">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-gap: 3rem;</div>
                        </div>
                        <div className="property-define">
                            You can use (r)em values.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-gap type3">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={rowStart}>
                <div className="name">grid-row-start</div>
                <div className="define">Defines the row start position of a grid item.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-start: auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            In this 3-column setup, the grid item is automatically placed on the first row.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-start type1">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-start: 2;</div>
                        </div>
                        <div className="property-define">
                            The target grid item is placed on the second row.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-start type2">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row-start: 3;</div>
                        </div>
                        <div className="property-define">
                            The target grid item is placed outside the grid, in an auto-generated third row.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row-start type3">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink"><strong>Target</strong></div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-orange">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={rowRef}>
                <div className="name">grid-row</div>
                <div className="define">Shorthand property for grid-row-start and grid-row-end.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row: auto auto;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            The grid item's row start and end are automatically set.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row type1">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row: 1 / 3;</div>
                        </div>
                        <div className="property-define">
                            The grid item starts before the first row and ends just before the third one.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row type2">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row: span 3;</div>
                        </div>
                        <div className="property-define">
                            The grid item spans 3 rows.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row type3">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row: 1 / span 4;</div>
                        </div>
                        <div className="property-define">
                            The grid items starts before the first row and spans for 4 rows, creating a new one in the process.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row type4">
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-pink">
                                        <strong>Target</strong>
                                    </div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                    <div className="block block-alpha">Item</div>
                                    <div className="block block-beta">Item</div>
                                    <div className="block block-yellow">Item</div>
                                    <div className="block block-purple">Item</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-row: header;</div>
                        </div>
                        <div className="property-define">
                            You can use an area name to "copy" its row start and end positions.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid row type5">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-yellow">Main</div>
                                    <div className="block block-purple">Footer</div>
                                    <div className="block block-pink"><strong>Targer</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={templateAreas}>
                <div className="name">grid-template-areas</div>
                <div className="define">Defines areas within a grid container. These areas can then be referenced when placing a grid item.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-areas: none;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            No area is defined.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-area type1">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-areas: "header header header" "sidebar main main";</div>
                        </div>
                        <div className="property-define">
                            You can use area names to specify which cells each grid item should occupy.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-area type2">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={templateColumns}>
                <div className="name">grid-template-columns</div>
                <div className="define">Defines the columns of a grid container. You can specify the width of a column by using a keyword (like auto) or a length (like 10px). The number of columns is determined by the number of values defined in the space-separated list.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-columns: none;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            No columns are defined, so you only have one.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-columns type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-columns: auto auto auto;</div>
                        </div>
                        <div className="property-define">
                            You can use the keyword auto so that each column resizes itself automatically.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-columns type2">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-columns: 80px auto 1rem;</div>
                        </div>
                        <div className="property-define">
                            You can mix the units.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-columns type3">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-columns: 40px 1fr 2fr;</div>
                        </div>
                        <div className="property-define">
                            You can use the fr flex unit to distribute the remaining space across all flex columns.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-columns type4">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={templateRows}>
                <div className="name">grid-template-rows</div>
                <div className="define">Defines the rows of a grid container. You can specify the width of a row by using a keyword (like auto) or a length (like 10px). The number of rows is determined by the number of values defined in the space-separated list.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-rows: none;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            No rows are defined.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-rows type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-rows: 120px auto 3rem;</div>
                        </div>
                        <div className="property-define">
                            You can mix the units.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-rows type2">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template-rows: 20px 1fr 2fr;</div>
                        </div>
                        <div className="property-define">
                            You can use the fr flex unit to distribute the remaining space across all flex rows.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template-rows type3">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={template}>
                <div className="name">grid-template</div>
                <div className="define">Shorthand property for grid-template-rows grid-template-columns and grid-template-area.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template: none;</div>
                            <div className="property-name-default">
                                default
                                <div className="property-name-default-hover">
                                    This is the property's default value
                                </div>
                            </div>
                        </div>
                        <div className="property-define">
                            No rows, columns, or areas are defined.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template type1">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template: 200px 1fr / 100px auto 3rem;</div>
                        </div>
                        <div className="property-define">
                            You can define rows first, columns second, by splitting them with a slash /.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template type2">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-orange"><strong>5.</strong> Five</div>
                                    <div className="block block-purple"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid-template: "header header header" 50px "sidebar main main" 200px / 100px auto;</div>
                        </div>
                        <div className="property-define">
                            You can define both areas and rows and columns dimensions. In this case, each set of areas have a row size attached to it. The first row is 50px high, the second one is 200px high. The sidebar column is 100px wide, while the main column's width is set to auto and takes up the remaining width.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid template type3">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="css-reference-content" ref={grid}>
                <div className="name">grid</div>
                <div className="define">Shorthand property for grid-template-rows grid-template-columns grid-template-areas grid-auto-rows grid-auto-columns and grid-auto-flow.</div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid: "header header header" 50px "sidebar main main" 200px / 100px auto;</div>
                        </div>
                        <div className="property-define">
                            You can use it as grid-template by setting all explicit rows, columns, and areas.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid grid type1">
                                    <div className="block block-alpha">Header</div>
                                    <div className="block block-beta">Sidebar</div>
                                    <div className="block block-pink">Main</div>
                                    <div className="block block-purple">Other</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid: 200px 100px / auto-flow 30%;</div>
                        </div>
                        <div className="property-define">
                            You can combine grid-template-rows with grid-auto-columns.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid grid type2">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-purple"><strong>5.</strong> Five</div>
                                    <div className="block block-orange"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contents-tab">
                    <div className="contents-title">
                        <div className="property-name-wrap">
                            <div className="property-name" onClick={clickCopyText}>grid: auto-flow 50px / 200px 100px;</div>
                        </div>
                        <div className="property-define">
                            You can combine grid-auto-rows with grid-template-columns.
                        </div>
                    </div>

                    <div className="contents-example">
                        <div className="contents-box-top"></div>
                        <div className="contents-box-output">
                            <div className="contents-output">
                                <div className="example-background-output css-grid grid type3">
                                    <div className="block block-alpha"><strong>1.</strong> One</div>
                                    <div className="block block-beta"><strong>2.</strong> Two</div>
                                    <div className="block block-pink"><strong>3.</strong> Three</div>
                                    <div className="block block-yellow"><strong>4.</strong> Four</div>
                                    <div className="block block-purple"><strong>5.</strong> Five</div>
                                    <div className="block block-orange"><strong>6.</strong> Six</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Cssgrid